import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Button from '@repo/ui/button'
import Typography from '@repo/ui/typography'

import useTranslate from '../../../lib/hooks/use-translate'

interface GuideCardProps {
  title: string
  pdfPath: string

  description?: string
  imagePath?: string
}

const GuideCard = ({ title, description, imagePath, pdfPath }: GuideCardProps) => {
  const { t } = useTranslate()

  return (
    <div className="flex mobile:flex-col flex-row mobile:items-center items-start justify-between gap-5 px-4 py-2.5 border border-grey-light bg-white-hover rounded-lg w-full">
      <div className="flex flex-col gap-4 items-start mobile:w-full w-auto">
        <div className="flex flex-col gap-1 items-start">
          <Typography variant="body-medium">{title}</Typography>
          {description && (
            <Typography
              variant="secondary-body"
              color={tailwindColors.grey.lighter}
              className="whitespace-pre-line"
            >
              {description}
            </Typography>
          )}
        </div>

        <Button
          label={t('staff.personal.space.my.journeys.details.tab.guide.cta')}
          variant="primary"
          onClick={() => window.open(pdfPath, '_blank', 'noopener,noreferrer')}
          className="mobile:w-full w-auto"
        />
      </div>

      {imagePath && (
        <div className="w-36 h-36 flex-shrink-0">
          <img src={imagePath} alt={title} className="object-cover w-full h-full" />
        </div>
      )}
    </div>
  )
}

export default GuideCard
